query Reference1Codes($Ref1CodeFilter: Reference1CodeFilter) {
  reference1Codes(orderBy: REFERENCE_CODE_ASC, filter: $Ref1CodeFilter) {
    nodes {
      name
      referenceCode
    }
  }
}
